// extracted by mini-css-extract-plugin
export default {"emailRegistration":"EmailRegistration_emailRegistration__f1OoB"};